/* Inscription guidée « pas à pas » (wizard). 100% tokens var(--gas-*).
   Les wrappers d'étape sont en display:contents → transparents pour la grille
   (.aph-form-grid) ; masqués via display:none quand l'étape n'est pas active. */

.gas-reg-step {
    display: contents;
}
.gas-reg-step.gas-reg-step--hidden {
    display: none;
}

.gas-reg-wizard__enter {
    margin-bottom: var(--gas-space-m);
}

.gas-reg-wizard {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-l);
}

.gas-reg-wizard__sidebar {
    background: var(--gas-bg-surface);
    border: var(--gas-border-width) solid var(--gas-color-border);
    border-radius: var(--gas-radius-l);
    padding: var(--gas-space-m);
}

.gas-reg-wizard__main {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-l);
    min-width: 0;
}

.gas-reg-wizard__guide {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-s);
    padding: var(--gas-space-m) var(--gas-space-l);
    /* Surface neutre adaptée au thème + accent primary à gauche (cf. profil). */
    background: var(--gas-bg-surface-alt);
    border: var(--gas-border-width) solid var(--gas-color-border);
    border-left: var(--gas-border-width-thick) solid var(--gas-color-primary);
    border-radius: var(--gas-radius-l);
}

.gas-reg-wizard__guide-title {
    margin: 0;
    font-size: var(--gas-text-l);
    color: var(--gas-color-text-strong);
}

.gas-reg-wizard__guide-body {
    margin: 0;
    color: var(--gas-color-text);
    line-height: 1.5;
    white-space: pre-line;
}

.gas-reg-wizard__guide-tip {
    display: flex;
    gap: var(--gas-space-xs);
    align-items: flex-start;
    margin: 0;
    padding: var(--gas-space-s) var(--gas-space-m);
    background: var(--gas-bg-surface);
    border-radius: var(--gas-radius-m);
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-s);
}

/* Feedback email live */
.gas-reg-email-status {
    margin: var(--gas-space-xs) 0 0;
    font-size: var(--gas-text-s);
    line-height: 1.4;
}
.gas-reg-email-status--checking {
    color: var(--gas-color-text-muted);
}
.gas-reg-email-status--ok {
    color: var(--gas-color-success, #0a7a3e);
}

/* Récap avant envoi */
.gas-reg-summary {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-s);
    padding: var(--gas-space-m) var(--gas-space-l);
    background: var(--gas-bg-surface-alt);
    border: var(--gas-border-width) solid var(--gas-color-border);
    border-radius: var(--gas-radius-l);
}
.gas-reg-summary__title {
    margin: 0;
    font-size: var(--gas-text-l);
    color: var(--gas-color-text-strong);
}
.gas-reg-summary__intro,
.gas-reg-summary__hint {
    margin: 0;
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-s);
    line-height: 1.45;
}
.gas-reg-summary__list {
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-xs);
}
.gas-reg-summary__row {
    display: grid;
    grid-template-columns: minmax(112px, 32%) 1fr;
    gap: var(--gas-space-s);
    padding: var(--gas-space-xs) 0;
    border-bottom: var(--gas-border-width) solid var(--gas-color-border);
}
.gas-reg-summary__row:last-child {
    border-bottom: 0;
}
.gas-reg-summary__row dt {
    margin: 0;
    font-weight: 600;
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-s);
}
.gas-reg-summary__row dd {
    margin: 0;
    color: var(--gas-color-text);
    word-break: break-word;
}

/* Trust line sous anti-bot */
.gas-reg-trust {
    margin: var(--gas-space-m) 0 0;
    font-size: var(--gas-text-s);
    color: var(--gas-color-text-muted);
    line-height: 1.45;
}
.gas-reg-trust a {
    color: var(--gas-color-primary);
}

.gas-registration-required-badge {
    display: inline-flex;
    align-items: center;
    width: fit-content;
    margin-left: var(--gas-space-xs);
    padding: 0 var(--gas-space-xs);
    border-radius: var(--gas-radius-full);
    background: var(--gas-warning-light);
    color: var(--gas-warning-text-strong);
    font-size: var(--gas-text-xs);
    font-weight: var(--gas-weight-semi);
    line-height: 1.6;
    vertical-align: middle;
}

.gas-registration-field-help-inline {
    display: block;
    margin-top: var(--gas-space-2xs);
    color: var(--gas-help-color);
    font-size: var(--gas-help-font-size);
    font-weight: var(--gas-weight-regular);
    line-height: var(--gas-leading-normal);
}

.gas-reg-wizard__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--gas-space-s);
    margin-top: var(--gas-space-m);
    padding: var(--gas-space-m) 0;
    border-top: var(--gas-border-width) solid var(--gas-color-border);
}

.gas-reg-wizard__footer-right {
    display: flex;
    gap: var(--gas-space-s);
}

@media (min-width: 768px) {
    .gas-reg-wizard {
        flex-direction: row;
        align-items: flex-start;
    }
    .gas-reg-wizard__sidebar {
        flex: 0 0 240px;
        position: sticky;
        top: var(--gas-space-l);
    }
    .gas-reg-wizard__main {
        flex: 1 1 auto;
    }
}
